import { ExperimentConfig } from '@redbubble/next-amplitude';
import { useAmplitudeExperiment } from '@redbubble/next-provider/amplitude';
var COUNTDOWN_WINDOW_HOURS_BY_ENROLMENT = new Map([
    ['treatment', Infinity],
    ['treatment-2', 48],
    ['treatment-3', 72],
]);
export var useSaleBannerExperiment = function (bannerMessages, saleBannerMessages, intl) {
    var _a, _b;
    var showCountdown = (_b = (_a = bannerMessages === null || bannerMessages === void 0 ? void 0 : bannerMessages[0]) === null || _a === void 0 ? void 0 : _a.showCountdown) !== null && _b !== void 0 ? _b : false;
    var enrolment = useAmplitudeExperiment(ExperimentConfig.SaleBannerCountdown, { skipExposure: !showCountdown });
    var countdownWindowHours = COUNTDOWN_WINDOW_HOURS_BY_ENROLMENT.get(enrolment);
    if (!showCountdown || countdownWindowHours === undefined) {
        return { coralSaleBannerWithShopNowAndInlineCountdown: false };
    }
    return {
        coralSaleBannerWithShopNowAndInlineCountdown: true,
        countdownWindowHours: countdownWindowHours,
        shopNowLabel: intl.formatMessage(saleBannerMessages.shopNow),
        countdownEndsInLabel: intl.formatMessage(saleBannerMessages.endsIn),
    };
};
